import { render, staticRenderFns } from "./NoTokens.vue?vue&type=template&id=37954fce&"
import script from "./NoTokens.vue?vue&type=script&lang=js&"
export * from "./NoTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports